import { rgba, rem } from "polished"

const infoblocks = {
  backgroundColor: ({ theme }) => rgba(theme.colors.white, 0.6),
  openBackgroundColor: ({ theme }) => theme.colors.white,
  borderColor: ({ theme }) => rgba(theme.colors.firefly, 0.2),
  borderRadius: rem(5),
}

export default infoblocks
